<template>
    <button class="btn btn-warning" @click="lulusData">
        <slot><i class="fas fa-flag"></i></slot>
    </button>
</template>

<script>
    import { EventBus } from '../eventBus.js';

    export default{
        //extends: ExampleComponent,
        props: ['id', 'name'],
        methods: {
            lulusData() {
                // alert(`I am ${this.name}!`)
                EventBus.$emit('lulusValue', this.id,this.name) 
            }
        },
    }
</script>